import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

/**
 * Per-route document <title> for in-app (client-side) navigation.
 *
 * The SERVER is the source of truth for SEO meta: the backend injects the
 * canonical, description and OG/Twitter tags per route into the served HTML
 * (see backend/utils/seoMeta.js), which is what crawlers read. We deliberately
 * do NOT re-emit canonical/description/OG here, because react-helmet-async would
 * append duplicates on top of the server-rendered tags. We only keep the title
 * in sync so the browser tab updates as the user navigates the SPA.
 *
 * Keep ROUTE_META titles in sync with backend/utils/seoMeta.js.
 */
const ROUTE_META = {
  "/": {
    title: "Cluck.us - The #1 US Sweepstakes Casino",
    description:
      "Play 1,000+ slots and table games with free Gold Coins, collect Cluck Bucks, and redeem real prizes. Crypto and fiat accepted. US sweepstakes casino.",
  },
  "/promotions": {
    title: "Promotions & Bonuses | Cluck.us Sweepstakes Casino",
    description:
      "Daily bonuses, reload offers, and free Gold Coin drops at Cluck.us. See the latest sweepstakes casino promotions.",
  },
  "/vip": {
    title: "VIP Rewards Program | Cluck.us",
    description:
      "Climb the Cluck.us VIP tiers for bigger rewards, faster redemptions, and exclusive perks.",
  },
  "/amoe": {
    title: "Free Entry (AMOE) | Cluck.us Sweepstakes Casino",
    description:
      "No purchase necessary. Request free Cluck Bucks via our Alternative Method of Entry (AMOE) at Cluck.us.",
  },
  "/terms": {
    title: "Terms of Service | Cluck.us",
    description: "The terms and conditions governing your use of Cluck.us.",
  },
  "/privacy": {
    title: "Privacy Policy | Cluck.us",
    description: "How Cluck.us collects, uses, and protects your personal information.",
  },
  "/responsible-gaming": {
    title: "Responsible Gaming | Cluck.us",
    description:
      "Cluck.us is committed to responsible play. Learn about our player-protection tools and support resources.",
  },
  "/providers": { title: "Game Providers | Cluck.us Sweepstakes Casino" },
  "/signup": { title: "Create Your Free Account | Cluck.us" },
  "/games/slots": { title: "Free Online Slots | Cluck.us" },
  "/games/table": { title: "Table Games | Cluck.us Sweepstakes Casino" },
  "/games/jackpots": { title: "Jackpot Games | Cluck.us" },
  "/games/live": { title: "Live Casino Games | Cluck.us" },
  "/games/instant": { title: "Instant Win Games | Cluck.us" },
};

const RouteSeo = () => {
  const { pathname } = useLocation();

  // Normalise trailing slash (keep "/" as-is) to match the server route map.
  const normalisedPath =
    pathname.length > 1 && pathname.endsWith("/")
      ? pathname.slice(0, -1)
      : pathname;

  const meta = ROUTE_META[normalisedPath];

  // Title only — canonical/description/OG are server-injected (single source of
  // truth) to avoid duplicate tags on hydration.
  if (!meta) return null;
  return (
    <Helmet>
      <title>{meta.title}</title>
    </Helmet>
  );
};

export default RouteSeo;
